import React from 'react';

export default (input) => (
	<div className="form-element ">
		<label className={
			`input input-text textbox-large ${input.error && document.activeElement.name !== input.name ? "error" : ""} ${input.disabled ? "disabled" : ""} `}

		>
			<span className={`label ${input.bold && 'bold-label'}`}>{input.label}</span>
			<div className="group">
				<textarea
					rows={input.rows || "5"}
					value={""}
					{...input}

				/>

				{(input.error && (document.activeElement.name !== input.name || input.value === "")) &&
					<p className="validation-message field-validation-error">{input.error}</p>}
			</div>
		</label>
	</div>
)